import AxiosConfig from '../Configuration/AxiosConfig'
import HeaderConfig from '../Configuration/HeaderConfig';
import { CheckInternetConnection } from '../Services/UtilitiesServices';

export function GoogleAuthentication(data)
{
  return AxiosConfig().post("Account/GoogleAuthentication",data, HeaderConfig());
}